var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 106,
    viewBox: "0 0 100 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.1013 37.7673L46.6466 57.9459L79.6078 49.6859C78.4742 45.4188 76.6108 41.3855 74.1013 37.7673Z",
    fill: "#A3D4FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7644 14.3325L46.3654 55.0663L79.451 30.7492C72.9426 22.0676 63.4074 16.2018 52.7644 14.3325Z",
    fill: "#1D95F7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9826 61.0536C42.8998 61.0389 42.8202 61.0097 42.7476 60.9673C42.7371 60.9633 42.7268 60.9589 42.7167 60.9539C42.7034 60.9435 42.6907 60.9323 42.6787 60.9203C42.6283 60.8849 42.583 60.8426 42.544 60.7947C42.5282 60.7752 42.5111 60.7582 42.4974 60.738C42.4502 60.6695 42.415 60.5933 42.3934 60.5128C42.3928 60.5101 42.3916 60.5077 42.3898 60.5056C42.3676 60.4117 42.3637 60.3144 42.3784 60.2189L48.2696 22.7174C27.994 19.9291 9.11062 34.0079 5.89388 54.4846C2.63885 75.2051 16.6553 94.6184 37.2009 97.8459C57.5075 101.036 76.5767 87.219 80.1625 66.898L42.9826 61.0536Z",
    fill: "#46B1FE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7818 51.1659L57.7153 59.4549L91.338 64.7368C91.9667 60.2142 91.7782 55.6165 90.7818 51.1659Z",
    fill: "#009DFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0022 8.80526C50.0022 8.80526 72.8727 10.0593 85.1877 29.7247",
    stroke: "#4EB2F9",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4041 6.23849L47.7983 10.7657",
    stroke: "#4EB2F9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4676 29.7599L83.6954 32.1242",
    stroke: "#4EB2F9",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.53
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.6464 57.9458L47.7451 57.6703L74.0065 38.3696C76.4063 41.8349 78.2145 45.6812 79.3565 49.7499L79.6073 49.6877C78.4737 45.4206 76.6103 41.3874 74.1009 37.7691L46.6464 57.9458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1352 59.676L90.6872 51.7682C91.6357 56.0185 91.8475 60.404 91.3134 64.731L91.3382 64.7349C91.9669 60.2124 91.7785 55.6146 90.7821 51.164L57.7156 59.453L59.1352 59.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1683 23.3187L48.2629 22.7163C27.9937 19.9291 9.11038 34.0079 5.89364 54.4846C5.87777 54.5857 5.86877 54.6849 5.85397 54.7851C9.20967 34.4727 27.9995 20.5453 48.1683 23.3187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9804 61.0542C42.8977 61.0396 42.8181 61.0104 42.7454 60.9679C42.7344 60.9662 42.7234 60.9645 42.7146 60.9545C42.7012 60.9442 42.6885 60.933 42.6765 60.921C42.6262 60.8856 42.5808 60.8433 42.5419 60.7954C42.5261 60.7758 42.509 60.7589 42.4952 60.7387C42.4481 60.6702 42.4129 60.594 42.3913 60.5135C42.3907 60.5108 42.3894 60.5083 42.3877 60.5063C42.3655 60.4124 42.3616 60.3151 42.3762 60.2196L42.2816 60.8219C42.2669 60.9174 42.2708 61.0148 42.2931 61.1086C42.2946 61.1111 42.2957 61.1139 42.2965 61.1167C42.3181 61.1973 42.3533 61.2735 42.4005 61.342C42.415 61.3614 42.4307 61.38 42.4472 61.3978C42.4864 61.4457 42.5317 61.4882 42.5818 61.5243C42.5953 61.534 42.6052 61.5489 42.6198 61.5578C42.6344 61.5667 42.641 61.5611 42.6507 61.5712C42.7236 61.6129 42.8032 61.6418 42.8858 61.6566L80.0415 67.4934C80.0804 67.2935 80.1273 67.0967 80.1628 66.8953L42.9804 61.0542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.4508 30.7492C72.9424 22.0676 63.4072 16.2019 52.7642 14.3326L52.6695 14.9349C63.166 16.7802 72.5895 22.5149 79.091 31.0137L79.4508 30.7492Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/Chart.44ac3dd4b855b9861d27eb4cbe5fecbc.svg";
export { ForwardRef as ReactComponent };